import { render, staticRenderFns } from "./DataimportAG.vue?vue&type=template&id=e90830b4&scoped=true"
import script from "./DataimportAG.vue?vue&type=script&lang=js"
export * from "./DataimportAG.vue?vue&type=script&lang=js"
import style0 from "./DataimportAG.vue?vue&type=style&index=0&id=e90830b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90830b4",
  null
  
)

export default component.exports